import mixpanel from 'mixpanel-browser';

const TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || '';

let initialized = false;

export function initMixpanel() {
  if (initialized || !TOKEN || typeof window === 'undefined') return;
  mixpanel.init(TOKEN, {
    track_pageview: false, // we handle page views manually for Next.js SPA routing
    persistence: 'localStorage',
    ignore_dnt: false,
  });
  initialized = true;
}

export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  if (!TOKEN || typeof window === 'undefined') return;
  try {
    initMixpanel();
    mixpanel.track(eventName, properties);
  } catch {
    // non-blocking
  }
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  if (!TOKEN || typeof window === 'undefined') return;
  try {
    initMixpanel();
    mixpanel.identify(userId);
    if (traits) {
      mixpanel.people.set(traits);
    }
  } catch {
    // non-blocking
  }
}

export function resetMixpanel() {
  if (!TOKEN || typeof window === 'undefined') return;
  try {
    initMixpanel();
    mixpanel.reset();
  } catch {
    // non-blocking
  }
}

export function trackPageView(path: string, title?: string) {
  trackEvent('Page Viewed', {
    page_path: path,
    page_title: title || document.title,
    page_url: window.location.href,
  });
}
